import { render, staticRenderFns } from "./OrderStatusChangeModal.vue?vue&type=template&id=5db99b2e&scoped=true&"
import script from "./OrderStatusChangeModal.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusChangeModal.vue?vue&type=style&index=0&id=5db99b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db99b2e",
  null
  
)

export default component.exports